import Cookies from 'js-cookie'

const REFERRAL_KEY = 'disco-referral'

export function readReferral() {
  try {
    const value = Cookies.get(REFERRAL_KEY)

    if (value) {
      return JSON.parse(value) || {}
    }

    return {}
  } catch (err) {
    console.error(err)
    return {}
  }
}

export function readSaveToDisco() {
  const query = new URLSearchParams(document.location.search)
  const savingObj = query.get('so') ?? ''
  const savingUrl = query.get('su') ?? ''

  if (savingObj || savingUrl) {
    return { savingObj, savingUrl }
  } else {
    return { savingObj: null, savingUrl: null }
  }
}

export function readReferralLanding() {
  try {
    return localStorage.getItem('landing') || undefined
  } catch (err) {
    console.error(err)
    return undefined
  }
}
